/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VmcProperties { 
    /**
     * Mapped VMC Org ID.
     */
    vmc_org_id?: string;
    vmc_org_type?: string;
    last_updated?: Date;
    vmc_md5_hash?: string;
    vmc_burst_enabled?: boolean;
    vmc_burst_info?: string;
    /**
     * vmc properties
     */
    vmc_properties?: object;
}

